module.exports = __webpack_public_path__ + "static/media/4.60bd3e3f.JPG";